export class accordionModule {
	accordionList: NodeList = document.querySelectorAll("[data-accordion]");
	accordionArray: HTMLElement[] = Array.prototype.slice.call(this.accordionList);
	accordionItem: NodeList = document.querySelectorAll("[data-accordion-item]");
	accordionItemBody: HTMLDivElement = document.querySelector("[data-accordion-body]");
	activeClass: string = "is-active";
	constructor() {
		this.accordion();
		window.addEventListener("resize", this.accordion, false);
	}
	// get siblings helper function
	private getSiblings = (elem) => {
		let siblings = [];
		let sibling = elem.parentNode.firstChild;
		for (; sibling; sibling = sibling.nextSibling) {
			if (sibling.nodeType !== 1 || sibling === elem) continue;
			siblings.push(sibling);
		}
		return siblings;
	}

	private accordion = () => {
		// each accordion
		this.accordionArray.forEach((element: HTMLElement) => {

			const childAccordionItems: HTMLCollection = element.children;
			const childAccordionItemsArray: HTMLElement[] = Array.prototype.slice.call(childAccordionItems);
			// each accordion item
			childAccordionItemsArray.forEach((listElement: HTMLElement) => {
				// get height of header
				let getHeadHeight: number = listElement.querySelector("[data-accordion-head]").clientHeight;
				let getBodyHeight: number = listElement.querySelector("[data-accordion-body]").clientHeight;
				let totalHeight: number = getHeadHeight + getBodyHeight;

				// default height and active class
				listElement.style.height = getHeadHeight + "px";
				listElement.classList.remove(this.activeClass);

				// toggle accordion on click
				const childAccordionItemsClick = listElement.querySelector("[data-accordion-head]");
				childAccordionItemsClick.addEventListener("click", (e: Event) => {

					let clickedElmParent = (e.currentTarget as HTMLElement).parentElement;
					let clickedElmParentSiblings = this.getSiblings(clickedElmParent);

					// toggle active class
					clickedElmParent.classList.toggle(this.activeClass);

					// add new height to header
					clickedElmParent.style.height = totalHeight + "px";

					// remove active class from siblings and set height
					clickedElmParentSiblings.forEach((siblingsElm: HTMLElement) => {
						siblingsElm.classList.remove(this.activeClass);
						siblingsElm.style.height = getHeadHeight + "px";
					})
					// close other if not active
					if (!clickedElmParent.classList.contains(this.activeClass)) {
						clickedElmParent.style.height = getHeadHeight + "px";
					}
				});
			});
		});
	}
}
